import { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { fetchTopPlayers } from '../../../../store/cache';

import './index.css';

const outfitServer = process.env.REACT_APP_OUTFIT_SERVER || 'https://ameriax.org/image_server/animoutfit.php';

export const PlayerCharacterComponent = ({ data, showName, width, height }) => {
    const navigate = useNavigate();
    const outfit = `${outfitServer}?id=${data.looktype ?? 0}&addons=${data.lookaddons ?? 0}&head=${data.lookhead ?? 0}&body=${data.lookbody ?? 0}&legs=${data.looklegs ?? 0}&feet=${data.lookfeet ?? 0}&direction=3`;

    const size = parseInt(width.split('px')[0]);

    const marginTop = `${15 - (size / 2)}px`;
    const marginLeft = `${10 - (size / 2)}px`;

    return (
        <div className='playercharacter-container' title={showName ? `View ${data.name}'s character` : undefined}
            style={{cursor: showName ? 'zoom-in' : 'default'}}
            onClick={() => navigate(`/character/${data.id}`)}
        >
            <div className='playercharacter-information-container'>
                {showName && <p>{data.name} ({data.level})</p>}
                <img
                    className='playercharacter-outfit-image'
                    style={{width, height, marginTop, marginLeft}}
                    src={outfit}
                    alt='Outfit'
                    loading="lazy"
                />
            </div>
        </div>
    );
};

const TopPlayerComponent = () => {
    const dispatch = useDispatch();
    const topPlayersData = useSelector(state => state?.cache?.topPlayers);
    const topPlayers = topPlayersData?.data;
    const topPlayersCacheTime = topPlayersData?.cacheTime;
    const featuredPlayer = topPlayers?.[0];
    const remainingPlayers = topPlayers?.slice(1);

    const getSecondsSinceCache = useCallback(() => {
        if (!topPlayersCacheTime) return 0;
        let timeNow = Date.now() / 1000;
        let lastUpdate = topPlayersCacheTime / 1000
        return parseInt(timeNow - lastUpdate);
    }, [topPlayersCacheTime]);

    useEffect(() => {
        if (!topPlayers || getSecondsSinceCache() >= 300) dispatch(fetchTopPlayers());
    }, [topPlayers, dispatch, getSecondsSinceCache]);

    return (
        <div id='topplayers-container'>
            {featuredPlayer && (
                <div className='topplayer-featured'>
                    <PlayerCharacterComponent
                        key={featuredPlayer.id}
                        data={featuredPlayer}
                        showName={true}
                        width='64px'
                        height='64px'
                    />
                </div>
            )}

            <div className='topplayers-grid'>
                {remainingPlayers?.map(player => (
                    <PlayerCharacterComponent
                        key={player.id}
                        data={player}
                        showName={true}
                        width='64px'
                        height='64px'
                    />
                ))}
            </div>
        </div>
    );
};

export default TopPlayerComponent;